import { ReactNode } from 'react';

interface TabPanelProps {
  children?: ReactNode;
  index: number;
  value: number;
}

const TabPanel = ({ children, value, index, ...other }: TabPanelProps) => {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`tabpanel-${index}`}
      aria-labelledby={`tab-${index}`}
      data-testid={`tab-panel-${index}`}
      {...other}
      style={{ width: '94%', margin: 'auto' }}
    >
      {value === index && children}
    </div>
  );
};

export default TabPanel;
